/**
 * Standalone helpers with no dependencies. Used by i18n/base so base does not
 * import utils/common (which would create a circular dependency with steps).
 */
export const capitalizeFirstLetter = (string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
